import Vue from 'vue';

const pageCount = 24;

const success = (context, response) => {
  context.users = response.users;
  context.usersPages = response.total > pageCount ? Math.trunc(response.total / pageCount) : 0;
  for(let user of context.users) {
    if(user.airbnb_accounts.length && !user.is_team_member) {
      user.airbnbTempBookingUpdate = {
        // airbnbAccount: null,
        confirmationCode: null,
        rentalId: null
      }
    }
  }
  context.loading = false;
};

const failed = (context, error) => {

};

export default (context) => {
  return Vue.$http.get('/users-search?search='+context.userSearch+'&offset='+context.usersPage*pageCount)
    .then(response => {
      if (response && response.status === 200) {
        success(context, response.data);
      } else {
        failed(context, response);
      }
    }).catch(error => {
      failed(context, error)
    })
}



// WEBPACK FOOTER //
// ./src/app/services/admin/searchUser.js